export default function Families() {
  return (
    <div>
      <p>Load the family table here</p>
    </div>
  );
}
